import DefaultLoader from "./DefaultLoader";
import React from "react";

export const SmallLoader = ({ color, type }) => (
  <div style={{ width: "40px" }}>
    <DefaultLoader
      color={color}
      size={16}
      style={{
        display: "block",
        textAlign: "center",
      }}
      type={type}
    />
  </div>
);

export default SmallLoader;
